import * as React from "react"
import * as classNames from "./CtxHeroSection.module.scss"
import Section from "../../../../core/layout/main/section/Section"
import PropTypes from "prop-types"
import Image from "../../blocks/image/Image"

const CtxHeroSection = ({
  children,
  image={},
  imgSrc = "",
  imgAlt = "",
  videoSrc = "",
  videoPoster = "",
  classes = "",
  hasGradient,
  heightPreset,
  ...otherProps
}) => {

  let heightClassName = ''

  switch(heightPreset){
    case 'pleine_hauteur': 
      heightClassName='hero_full';
      break;
    case 'petite_hauteur':
      heightClassName='hero_small';
      break;
    case 'auto':
      heightClassName='hero_auto';
      break;
  }

  hasGradient === null && (hasGradient = false)
  return (
    <Section
      className={`p-0 ${classNames.hero} ${classes} ${heightClassName} ${hasGradient ? classNames.gradient : classNames.noGradient}`}
      {...otherProps}
    >
      <div className={`${classNames.heroMedia}`}>
        {!videoSrc && (
          <figure className={classNames.heroFigure}>
            <picture className={classNames.heroPicture}>
              <Image
                dataSizesPreset={"hero"}
                imgSrc={imgSrc}
                imgAlt={imgAlt}
                formats={image?.formats}
                className={"hero"}
                style={{
                  position: "relative"
                }}
              />
            </picture>
          </figure>
        )}
        {videoSrc && (
          <video
            controls={false}
            preload="auto"
            muted={true}
            autoPlay={true}
            loop={true}
            playsInline={true}
            poster={videoPoster}
            style={{
              gridArea: "1/1",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "relative"
            }}
          >
            <source
              src={videoSrc}
              type="video/mp4"
            />
          </video>
        )}
      </div>
      <div className={`${classNames.heroContent} pb-4 pb-md-0 fade-in-bottom`}>
        {children}
      </div>
    </Section>
  )
}

export const name = "CtxHeroSection"

export const init = (componentData, pageContext) => {
  return <CtxHeroSection  key={componentData.id} />
}

CtxHeroSection.defaultProps = {
  children: null,
  imgSrc: "",
  imgAlt: "",
  videoSrc: "",
  videoPoster: "",
  classNames: "",
  hasGradient: null,
}

CtxHeroSection.propTypes = {
  children: PropTypes.node,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  videoSrc: PropTypes.string,
  videoPoster: PropTypes.string,
  classNames: PropTypes.string,
  hasGradient: PropTypes.bool,
}

export default CtxHeroSection
